import { useEffect } from 'react'

import { FetchError } from 'lib/fetcher'
import { store } from 'lib/store'

export function useGTMFetchErrorHandling(error: FetchError): void {
	useEffect(() => {
		if (error) {
			if (error.status === 429) {
				return
			}

			store.dispatch({
				type: 'toast/set',
				payload: { kind: 'error', timeout: 6000, message: 'Something went wrong' },
			})
		}
	}, [error])
}
